import setupInterceptors from '@/services/setupInterceptors';
import axios from 'axios';
import { loginObj } from '@/services/base';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['dataops']) {
  appApisGTW = axios.create({
    // baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8000')
    baseURL: 'https://dev-itcbi-matilliondev-run-usct1-temp-qmuzefzuga-uc.a.run.app'.replace('{PORT}', ':8000')
  });
} else {
  appApisGTW = axios.create({
    // baseURL: 'https://dev-itcbi-matilliondev-run-usct1-temp-qmuzefzuga-uc.a.run.app'.replace('{PORT}', ':8000')
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
export default {
  getInEnviroments: function getInEnviroments() {
    var login = loginObj();
    var body = {
      login: login
    };
    return appApisGTW.get("/versionori").then(function (response) {
      return response.data;
    });
  },
  getOutEnviroments: function getOutEnviroments() {
    var login = loginObj();
    var body = {
      login: login
    };
    return appApisGTW.get("/versiondesclodrun", body).then(function (response) {
      return response.data;
    });
  },
  postJobsOrigs: function postJobsOrigs(version) {
    var login = loginObj();
    var body = {
      login: login,
      version: version
    };
    return appApisGTW.post("/jobsori", body).then(function (response) {
      return response.data;
    });
  },
  postVarsori: function postVarsori(version, job) {
    var login = loginObj();
    var body = {
      login: login,
      version: version,
      job: job
    };
    return appApisGTW.post("/getvarsori", body).then(function (response) {
      return response.data;
    });
  },
  saveOrchestrator: function saveOrchestrator(data) {
    var login = loginObj();
    // const body = { login, data }
    return appApisGTW.post("/importjob", data).then(function (response) {
      return response.data;
    });
  },
  importScripts: function importScripts(data) {
    var login = loginObj();
    // const body = { login, data }
    return appApisGTW.post("/importscripts", data).then(function (response) {
      return response.data;
    });
  },
  executionsList: function executionsList(date) {
    var login = loginObj();
    var body = {
      login: login,
      date: date
    };
    return appApisGTW.post("/jobsoritask", body).then(function (response) {
      return response.data;
    });
  }
};